/**
 * LP Parallax - Universal JS Fallback
 * Works with any section that uses CSS custom properties for parallax:
 * --offset-x, --parallax-start, --parallax-end
 *
 * Only runs when CSS Scroll-Driven Animations are NOT supported
 * and prefers-reduced-motion is NOT enabled
 *
 * Usage: Add data-parallax-container to the parent element
 *        Add data-parallax to each element that should animate
 */

(function () {
  // Check if reduced motion is preferred
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  // Check if CSS Scroll-Driven Animations are supported
  const supportsScrollTimeline = CSS.supports('animation-timeline', 'view()');
  if (supportsScrollTimeline) return;

  // Find all parallax containers
  const containers = document.querySelectorAll('[data-parallax-container]');
  if (containers.length === 0) return;

  containers.forEach((container) => {
    initParallax(container);
  });

  function initParallax(container) {
    // Find all parallax elements within this container
    const elements = [];
    const parallaxElements = container.querySelectorAll('[data-parallax]');

    parallaxElements.forEach((el) => {
      const styles = getComputedStyle(el);
      elements.push({
        element: el,
        offsetX: styles.getPropertyValue('--offset-x').trim() || '0',
        parallaxStart: parseFloat(styles.getPropertyValue('--parallax-start')) || 0,
        parallaxEnd: parseFloat(styles.getPropertyValue('--parallax-end')) || 0
      });
    });

    if (elements.length === 0) return;

    let ticking = false;
    let isVisible = false;

    // Calculate progress similar to CSS "cover 0% cover 100%"
    function updateParallax() {
      const rect = container.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // Progress: 0 when element top reaches viewport bottom, 1 when element bottom reaches viewport top
      const start = viewportHeight;
      const end = -rect.height;
      const current = rect.top;
      const progress = Math.max(0, Math.min(1, (start - current) / (start - end)));

      elements.forEach(({ element, offsetX, parallaxStart, parallaxEnd }) => {
        const parallaxY = parallaxStart + (parallaxEnd - parallaxStart) * progress;
        element.style.translate = `${offsetX} ${parallaxY}%`;
      });
    }

    function onScroll() {
      if (!ticking && isVisible) {
        requestAnimationFrame(() => {
          updateParallax();
          ticking = false;
        });
        ticking = true;
      }
    }

    // IntersectionObserver to detect when container is visible
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isVisible = entry.isIntersecting;
          if (isVisible) {
            updateParallax();
          }
        });
      },
      {
        rootMargin: '50px 0px',
        threshold: 0
      }
    );

    observer.observe(container);
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
